

class HeaderLink extends HTMLElement {
  tabLink; offcanvas;
  static classes = {
    active: 'active'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.tabLink = document.querySelector(this.dataset.tab);
    this.offcanvas = document.querySelector(this.dataset.bsTarget);

    // Al mouseover apre il dropdown del menu header (desktop)
    this.addEventListener('mouseover', () => {
      this.open();
    });
  }

  open = () => {
    // Mostra il tab e l'offcanvas associati quando un link header è attivato
    this.tabLink.show();
    this.show();

    // Se c'è un offcanvas, lo istanzia se non esiste già
    if(this.offcanvas != undefined && !this.offcanvas.classList.contains('show')){
      const offcanvas = bootstrap.Offcanvas.getInstance(this.offcanvas) || new bootstrap.Offcanvas(this.offcanvas);
      offcanvas.show();
    }
  }

  show = () => {
    // Nasconde tutti gli altri header-link attivi per garantire che solo uno sia visibile
    document.querySelectorAll('header-link').forEach((link) => {
      link.hide();
    });
    this.classList.add(HeaderLink.classes.active);
  }

  hide = () => {
    this.classList.remove(HeaderLink.classes.active);
  }
}
if (!window.customElements.get("header-link")) {
  window.customElements.define("header-link", HeaderLink);
}

class HeaderMobileTab extends HTMLElement {
  static classes = {
    active: 'active'
  }
  // Stack dei pannelli aperti: il menu mobile è un drill-down lineare, l'ultimo è quello in primo piano.
  static stack = [];

  constructor() {
    super();
  }

  connectedCallback() {
    // I sottolivelli partono fuori schermo (left:-100%): finché non sono attivi NON devono essere
    // raggiungibili da tastiera/screen reader, altrimenti il focus finisce su link invisibili coperti
    // dal pannello in primo piano (WCAG 2.4.11 Focus Not Obscured). inert li disattiva del tutto.
    if (!this.classList.contains(HeaderMobileTab.classes.active)) this.inert = true;
  }

  show = () => {
    this.classList.add(HeaderMobileTab.classes.active);
    if (!HeaderMobileTab.stack.includes(this)) HeaderMobileTab.stack.push(this);
    HeaderMobileTab.updateInert();
    // Porta il focus dentro il nuovo livello (sul controllo "indietro") invece di lasciarlo
    // sull'elemento appena reso inert nel livello precedente.
    const firstFocusable = this.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) firstFocusable.focus();
  }

  hide = () => {
    this.classList.remove(HeaderMobileTab.classes.active);
    const i = HeaderMobileTab.stack.indexOf(this);
    if (i !== -1) HeaderMobileTab.stack.splice(i, 1);
    HeaderMobileTab.updateInert();
    // Riporta il focus sul livello tornato in primo piano (o sulla lista di 1° livello).
    const top = HeaderMobileTab.stack[HeaderMobileTab.stack.length - 1];
    const region = top || document.querySelector('#side-mobile .position-relative');
    const focusable = region && region.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
    if (focusable) focusable.focus();
  }

  // Solo il pannello in cima allo stack (o la lista di 1° livello, se nessuno è aperto) resta
  // operabile; tutto il resto è inert → niente focus su contenuto non visibile.
  static updateInert = () => {
    const top = HeaderMobileTab.stack[HeaderMobileTab.stack.length - 1] || null;
    document.querySelectorAll('#side-mobile header-mobile-tab').forEach((panel) => {
      panel.inert = panel !== top;
    });
    const base = document.querySelector('#side-mobile .position-relative > ul.nav');
    if (base) base.inert = top !== null;
  }
}
if (!window.customElements.get("header-mobile-tab")) {
  window.customElements.define("header-mobile-tab", HeaderMobileTab);
}

class HeaderMobileLink extends HTMLElement {
  target;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.target = document.querySelector(this.dataset.tab) || document.querySelector(this.dataset.close);

    if(this.target != undefined && this.target.tagName == 'HEADER-MOBILE-TAB'){
      this.addEventListener('click', () => {
        if(this.dataset.close != undefined)
          this.target.hide();
        else
          this.target.show();
      });
    }
  }

  hide = () => {
    this.classList.remove(HeaderMobileTab.classes.active);
  }
}
if (!window.customElements.get("header-mobile-link")) {
  window.customElements.define("header-mobile-link", HeaderMobileLink);
}

class HeaderSearchResults extends HTMLElement {
  input;
  static classes = {
    hide: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.input = document.querySelector(this.dataset.searchBar);

    // 4.1.3: regione di stato persistente (fuori dal contenuto sostituito) per annunciare
    // agli screen reader la comparsa dei suggerimenti / l'assenza di risultati.
    this.liveRegion = document.createElement('div');
    this.liveRegion.setAttribute('role', 'status');
    this.liveRegion.setAttribute('aria-live', 'polite');
    this.liveRegion.className = 'visually-hidden';
    this.insertAdjacentElement('beforebegin', this.liveRegion);

    this.input.addEventListener('input', (e) => {
      this.search(e.target.value);
    });
  }

  search = (terms) => {
    // Non fa la ricerca se hai scritto meno di 3 caratteri (riduce il carico server)
    if(terms.length < 3){
      this.classList.add(HeaderSearchResults.classes.hide);
      this.liveRegion.textContent = '';
    } else {
      // Chiama l'API Shopify di search suggest per ottenere risultati in real-time
      axios.get(`${window.Shopify.routes.root}search/suggest?section_id=render-search&q=${terms}&resources[type]=query,${this.dataset.searchTypes}`)
      .then((response) => {
        // Sostituisce il DOM con i risultati e li mostra
        this.innerHTML = response.data;
        this.classList.remove(HeaderSearchResults.classes.hide);
        // 4.1.3: copia il messaggio di stato localizzato nella regione live (annuncio SR)
        const status = this.querySelector('[data-search-status]');
        this.liveRegion.textContent = status ? status.textContent.trim() : '';
        // Emette un evento per notificare altre parti dell'app che i risultati sono pronti
        window.dispatchEvent(new CustomEvent(Utils.E_SEARCH_RESULT, { detail: { terms: terms, results: this.querySelectorAll('search-result') } }));
      });
    }
  }
  
} 
if (!window.customElements.get("header-search-results")) {
  window.customElements.define("header-search-results", HeaderSearchResults);
}

class SideDesktop extends HTMLElement {
  
  constructor() {
    super();
  }
  

}

if (!window.customElements.get("side-desktop")) {
  window.customElements.define("side-desktop", SideDesktop);
}

class SideTab extends HTMLElement {
  static classes = {
    active: 'd-block',
    hidden: 'd-none'
  }

  constructor() {
    super();
  }

  show = () => {
    document.querySelectorAll('side-tab').forEach((tab) => {
      tab.hide();
    });
    this.classList.add(SideTab.classes.active);
    this.classList.remove(SideTab.classes.hidden);
  }

  hide = () => {
    this.classList.remove(SideTab.classes.active);
    this.classList.add(SideTab.classes.hidden);
  }
}
if (!window.customElements.get("side-tab")) {
  window.customElements.define("side-tab", SideTab);
}

class AnnouncementsBar extends HTMLElement {
  static classes = {
    hidden: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    console.log('AnnouncementsBar initialized colonna');

    const delay = this.dataset.delay || 5000; // Default to 5000ms if not specified

    document.addEventListener("DOMContentLoaded", function () {
      const messages = document.querySelectorAll('.announcement-message');
      let index = 0;

      setInterval(() => {
        messages[index].classList.remove('active');
        index = (index + 1) % messages.length;
        messages[index].classList.add('active');
      },  delay);
    });

  }

}
if (!window.customElements.get("announcements-bar")) {
  window.customElements.define("announcements-bar", AnnouncementsBar);
}


function sideDesktop() {
    return {
      state: { open: false, firstLevel: null, secondLevel: null },

      handleArrowKey(el, direction) {
        const container = el.closest('ul');
        if (!container) return;
        const items = Array.from(
          container.querySelectorAll(':scope > li > span[tabindex], :scope > li > a')
        );
        const index = items.indexOf(el);
        const target = direction === 'down' ? items[index + 1] : items[index - 1];
        if (target) target.focus();
      },

      handleEscape() {
        if (this.state.secondLevel != null) {
          const firstLevel = this.state.firstLevel;
          this.state.secondLevel = null;
          this.$nextTick(() => {
            const container = document.querySelector(`#second-menu-${firstLevel}`);
            if (container) {
              const trigger = container.querySelector('span[tabindex="0"]');
              if (trigger) trigger.focus();
            }
          });
        } else if (this.state.firstLevel != null) {
          const firstLevel = this.state.firstLevel;
          this.state.firstLevel = null;
          this.$nextTick(() => {
            const triggers = document.querySelectorAll('.megamenu-first > li > span[tabindex="0"]');
            const trigger = triggers[firstLevel - 1];
            if (trigger) trigger.focus();
          });
        } else {
          const offcanvasElement = document.querySelector('#side-desktop');
          const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement) || new bootstrap.Offcanvas(offcanvasElement);
          offcanvas.hide();
        }
      },

      setState(firstLevel, secondLevel) {
        this.state.firstLevel = firstLevel;
        this.state.secondLevel = secondLevel;
      },

      resetState() {
        this.state.open = false;
        this.state.firstLevel = null;
        this.state.secondLevel = null;
      },

      setOpen() {
        this.state.open = true;
      }
    }
  }

  document.querySelector('side-desktop').addEventListener('hide.bs.offcanvas', (e) => {
    document.querySelector('side-desktop').dispatchEvent(new CustomEvent('hideoffcanvas'));
  });
  document.querySelector('side-desktop').addEventListener('show.bs.offcanvas', (e) => {
    document.querySelector('side-desktop').dispatchEvent(new CustomEvent('showoffcanvas'));
  });

// WCAG 2.1.1 / aria-modal: con un offcanvas modale aperto, lo sfondo (header, main, footer)
// diventa inert → la tastiera non può uscire dal menu e gli screen reader ignorano lo sfondo,
// onorando davvero aria-modal="true". inert assolve sia il keyboard trap sia l'inertness AT,
// e degrada con grazia dove non supportato (resta il focus-trap di Bootstrap).
(() => {
  const setBackgroundInert = (on) => {
    document
      .querySelectorAll('.shopify-section-group-group-header, #MainContent, #footer')
      .forEach((el) => { el.inert = on; });
  };
  document.querySelectorAll('.offcanvas[aria-modal="true"]').forEach((offcanvas) => {
    offcanvas.addEventListener('show.bs.offcanvas', () => setBackgroundInert(true));
    offcanvas.addEventListener('hide.bs.offcanvas', () => setBackgroundInert(false));
  });
})();